import { getIsSearchGoogleModalShown } from '@bridebook/web/lib/shortlist/selectors';
import { useSelector } from '@bridebook/web/lib/utils';
import { lazyComponent } from '@bridebook/web/lib/utils/lazy/lazy-component';
import { memo } from 'react';

const SearchGoogleModal = lazyComponent(() => import('.'));

const SearchGoogleModalLazy: React.FC = () => {
  const show = useSelector(getIsSearchGoogleModalShown);

  if (!show) {
    return null;
  }

  return <SearchGoogleModal />;
};

export default memo(SearchGoogleModalLazy);
